import {ShieldCheck, Target, HeartHandshake, Lightbulb, Users2, Gauge} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export const mission = 'Proteger pessoas, patrimônios e operações críticas por meio de soluções tecnológicas de segurança e conectividade, entregues com excelência técnica e compromisso com o resultado do cliente.'

export const vision = 'Ser reconhecida como a consultoria de segurança tecnológica referência em inovação, qualidade e relacionamento com nossos clientes.'

export interface CoreValue {
  id: string
  icon: LucideIcon
  title: string
  description: string
}

export const coreValues: CoreValue[] = [
  {
    id: 'v1',
    icon: ShieldCheck,
    title: 'Integridade',
    description: 'Agimos com transparência e ética propondo soluções sob medida para cada projeto.',
  },
  {
    id: 'v2',
    icon: Target,
    title: 'Excelência Técnica',
    description: 'Investimos continuamente em certificações e capacitação para entregar soluções tecnicamente robustas e duradouras.',
  },
  {
    id: 'v3',
    icon: HeartHandshake,
    title: 'Compromisso com o Cliente',
    description: 'Construímos relações de confiança de longo prazo, priorizando o suporte contínuo após a implantação.',
  },
  {
    id: 'v4',
    icon: Lightbulb,
    title: 'Inovação Constante',
    description: 'Acompanhamos as tendências tecnológicas para oferecer sempre as soluções mais eficientes do mercado.',
  },
  {
    id: 'v5',
    icon: Users2,
    title: 'Valorização das Pessoas',
    description: 'Nosso time é o nosso maior ativo. Investimos em desenvolvimento, segurança e bem-estar de cada colaborador.',
  },
  {
    id: 'v6',
    icon: Gauge,
    title: 'Eficiência e Agilidade',
    description: 'Otimizamos processos para entregar projetos no prazo, com previsibilidade de custos e cronograma.',
  },
]
